module.exports = __webpack_public_path__ + "static/img/view.16f6dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/view.png
// module id = KLA/
// module chunks = 1